import { Leaves } from '../../../../libs/types'
import { ColumnFilterItem } from 'antd/lib/table/interface'

export type DataIndex = Leaves<DividendEvent>

export type DividendEvent = {
  dividendEventID: string
  stage: number
  paymentDate: string
  status: string
  type: string
  amount: string
  annualDividends: string
  feeTotal: string
  fees: {
    value: string
    name: string
    type: string
  }[]
  propertyId: string
  name: string
  tokenAmount: string
  propertyPrice: string
  investmentStrategy: {
    type: string
    name: string
  }
  stages: number
  updatedByUsername: string
  createdAt: string
  updatedAt: string
}

export type GetDividendEventsResponse = {
  dividendEvents: DividendEvent[]
}

export type FilterItems = {
  propertyId: ColumnFilterItem[]
  name: ColumnFilterItem[]
  type: ColumnFilterItem[]
  status: ColumnFilterItem[]
}

export const defaultFilterItems = {
  propertyId: [],
  name: [],
  type: [],
  status: [],
}
